import { useQuery } from "@tanstack/react-query";
import { getProjectCallTypes } from "@/app/actions/call/types/get/action";
import { QueryKey } from "@/app/vars/QueryKeys";

export function useFetchProjectCallTypes(options: { projectId?: number; enabled?: boolean } = {}) {
  const { projectId, enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.PROJECT_CALL_TYPES, projectId],
    queryFn: async () => {
      if (!projectId) return [];
      return await getProjectCallTypes(projectId);
    },
    enabled: enabled && !!projectId,
    staleTime: Infinity,
  });
}
